import clsx from 'clsx';
import Link from 'next/link';

import { Icon } from 'common/icon';
import { Header } from 'components/slider/header';

import styles from './styles.module.css';

interface EpmtyCardProps {
  headerName: string;
  headerCount: string;
  textSearch: string;
  url: string;
}

export const EpmtyCard = ({
  url,
  headerName,
  headerCount,
  textSearch,
}: EpmtyCardProps) => {
  return (
    <section className={styles.cards}>
      <div className={styles.container_s}>
        <Header hasIcon={false} name={headerName} count={headerCount} />
        <div className={styles.cards__row}>
          <div className={clsx(styles.cards__card, styles.empty_card)}>
            <Link href={url ?? ''} className={styles.empty_card__wrapper}>
              <div className={styles.empty_card__save}>
                <Icon.Smile />
                <span>{'No saved'}</span>
              </div>
              <div className={styles.empty_card__search}>
                <span>{textSearch}</span>
                <Icon.Arrow />
              </div>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};
